/* global LightrailUI */

import React, { useState, useRef, useEffect } from 'react';
import { PrimaryButton } from 'scy/buttons';
import styles from './styles.mod.scss';

function LightrailPurchase({ shopperToken, login }) {
  const lightrailDialog = useRef();
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [dialogLoaded, setDialogLoaded] = useState(false);

  useEffect(() => {
    if (shopperToken && scriptLoaded) {
      const lightrailUI = new LightrailUI(shopperToken);
      const dialog = lightrailUI.components.cardPurchaseDialog();
      dialog.on('ready', () => setDialogLoaded(true));
      dialog.mount();
      lightrailDialog.current = dialog;
    }
  }, [scriptLoaded, shopperToken]);

  useEffect(() => {
    const id = 'lightrail-ui-script';
    let scriptTag = document.getElementById(id);

    if (scriptTag) {
      setScriptLoaded(true);
    } else {
      scriptTag = document.createElement('script');
      scriptTag.src =
        'https://embed.lightrail.com/dropin_v2/v2/lightrail-ui.js';
      scriptTag.id = id;
      scriptTag.onload = function handleScript() {
        setScriptLoaded(true);
      };
      document.head.appendChild(scriptTag);
    }
  }, []);

  function openDialog() {
    return lightrailDialog.current && lightrailDialog.current.open();
  }

  return (
    <div className={styles.lightrail}>
      <PrimaryButton
        onClick={shopperToken ? openDialog : login}
        disabled={shopperToken && !dialogLoaded}
      >
        Buy a Gift Card
      </PrimaryButton>
    </div>
  );
}

export default LightrailPurchase;
